import { API_BASE_URL, API_LOCAL_URL, API_NODE_URL } from '~/constants';
import api from '~/services/api';

class OrcamentoService {
  _strategy = null;

  constructor() {
    this._strategy = new OrcamentoOnlineService();
  }

  setStategy(isOffline = false) {
    this._strategy = isOffline ? new OrcamentoOfflineService() : new OrcamentoOnlineService();
  }

  getAll(payload) {
    return this._strategy.getAll(payload);
  }

  syncManual(){
    return this._strategy.syncManual()
  }
}

export class OrcamentoOnlineService {
  async getAll({ skip, top, filter, orderby }, opts) {
    const params = {
      $top: top ? top : 100,
      $skip: skip,
      $orderby: orderby ? orderby : 'logCriacao desc',
      $select:
        'id,serie,numero,dataEmissao,clienteNome,clienteCpfCnpj,clienteTelefone,valorTotal,situacao,cancelado,logCriacao,logAtualizacao,informacaoComplementar,entregaUf,entregaCep,entregaLogradouro,entregaLogradouroNumero,entregaComplemento,entregaBairro,entregaIntCidadeId,enderecoUf,enderecoCep,enderecoLogradouro,enderecoLogradouroNumero,enderecoComplemento,enderecoBairro,enderecoIntCidadeId,intAssinaturaId',
      $expand: [
        'fisOperacao($select=descricao)',
        'fatVendedor($select=nome)',
        'fatCondicaopagamento($select=descricao)',
        'finMeiopagamento($select=descricao)',
        'intCliente($select=razaoSocial,telefone,celular,pjCnpj,pfCpf,email,codigoInterno)',
        'enderecoIntCidade',
        'entregaIntCidade',
        'fatTabelavenda($select=descricao)',
        'itens($select=produtoCodigo,produtoDescricao,produtoUnidadeComercial,itemValorUnitario,itemValorBruto,itemValorAcrescimoCondicao,itemQuantidade,itemValorDesconto,itemValorAcrescimo,itemValorFrete,itemValorSeguro,itemValorDespesa,itemValorTotal,itemOrdem,itemCancelado,produtoEstProdutoId,estProdutoAmbienteId;$expand=produtoEstProduto($select=id,foto,pesoLiquido,pesoBruto),estProdutoAmbiente($select=id,descricao))',
        'intAssinatura($select=id,assinatura,logAtualizacao)',
        // 'parcelas($expand=finMeiopagamento($select=descricao,id))', TODO: comentado no merge dev/offline-first
      ].join(',')
    };
    let res = await api.get(
      `${API_BASE_URL}/v1/faturamento/orcamento/`,
      {
        params: filter.length > 0 ? { ...params, $filter: [...filter]?.join(` and `) } : { ...params },
        ...opts
      }
    );

    return res;

  }

  cancelarOrcamento(orcamentoId, tokenLiberacaoRotina) {
    return api.put(
      `${API_BASE_URL}/v1/faturamento/orcamento/cancelar/${orcamentoId}`,
      {
        headers: {
          Authorization: tokenLiberacaoRotina ? `Bearer ${tokenLiberacaoRotina}` : null
        }
      }
    );
  }
  
}

export class OrcamentoOfflineService {
  getAll(opts) {
    return api.get(`${API_LOCAL_URL}/faturamento/orcamento/situacao/todos`, opts);
  }
  syncManual(payload) {
    return api.post(`${API_LOCAL_URL}/sync/orcamento/`, payload);
  }
}

export default new OrcamentoService();
